module.exports = __webpack_public_path__ + "media/flags/fi-87640d66.svg";